import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import {
    Button, ModalNextProvider,
} from '@jutro/components';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { ServiceManager } from '@jutro/services';
import _ from 'lodash';
import { useAuthentication } from 'gw-digital-auth-react';
// eslint-disable-next-line import/no-unresolved
import { withRouter} from 'react-router-dom';
import metadata from './AgentListViewPage.metadata.json5';
import styles from './AgentListView.module.scss';
import { SasriaAgentSignupService } from '../../../../../../common/capabilities/gw-capability-agentsignup-sasria';



function AgentListViewPage(props) {
    const [userTable, setuserTable] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const localeService = ServiceManager.getService('locale-service');
    const userData = useAuthentication();

    const {
        history: { location: { state } },
    } = props;

    const { location, history } = props;

    const CreateNewUser = useCallback(() => {
        return history.push({
            pathname: '/agentsignup',
            state: {
                redirectPath: '/agentsignupviewlist'
            }
        });
    }, [history]);

    const processUserDataData = useCallback(
        (userData) => {
            if (!_.isEmpty(userData)) {
                let userArrayResult = userData;
                userArrayResult = userArrayResult.map((userInfo) => {
                    console.log(userInfo);
                    const users = {
                        firstname: userInfo.name.givenName,
                        lastname: userInfo.name.familyName,
                        emailaddress: userInfo.emails[0].value,
                        useraccess: userInfo.useraccess
                    };
                    return users;
                });
                return userArrayResult;
            }
            return [];
        },
    );

    const getUsers = useCallback(
        () => {
            const userPromise = SasriaAgentSignupService.getUserSummary(userData.user_name);
            return userPromise
                .then((responseData) => {
                    const data = processUserDataData(responseData);
                    setuserTable(data);
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [processUserDataData]
    );



    const loadUserData = useCallback(
        () => {
            return getUsers();
        },
        []
    );

    useEffect(() => {
        loadUserData();
    }, []);


    const handleResend = useCallback((emailAddress) => {
        return SasriaAgentSignupService.setPassword(emailAddress, null)
            .then(() => {
                ModalNextProvider.showAlert({
                    title: 'ResendLink  Button clicked',
                    message: 'Resend Link has been sent to ' + emailAddress,
                    status: 'info',
                    icon: 'mi-info-outline'
                }).catch(_.noop);
            })
    });

    const handleEdit = useCallback((email, firstname, lastname, useraccess) => {
        return history.push({
            pathname: '/agentsignup',
            state: {
                redirectPath: '/agentsignupviewlist',
                emailAddress: email,
                firstName: firstname,
                lastName: lastname,
                userAccess: useraccess,
                isCalledForEditing: true
            }
        });
    }, [history]);


    const handleDeactivate = useCallback((emailAddress) => {
        return SasriaAgentSignupService.deactivateUser(emailAddress, null)
            .then(() => {
                return history.push({
                    pathname: '/userselectionlist',
                    state: {
                        redirectPath: '/agentsignupviewlist',
                        deactivatedUser: emailAddress,
                        isCalledForDeactivation: true
                    }
                });
            });

    }, [history]);

    const editUser = useCallback(
        (item, index, property) => {
            const _emailAddress = item.emailaddress;
            const _firstName = item.firstname;
            const _lastname = item.lastname;
            const _useraccess = item.useraccess;
            return (
                <Button onClick={() => {
                    handleEdit(_emailAddress, _firstName, _lastname,_useraccess);
                }}
                >
                    {'Edit'}
                </Button>
            );
        }
    );

    const resendLink = useCallback(
        (item, index, property) => {
            const emailAddress = item.emailaddress;
            return (
                <Button style={{ background: "rgb(242,175,0)" }}
                    onClick={() => {
                        handleResend(emailAddress);
                    }}
                >
                    {'Resend Link'}
                </Button>
            );
        }
    );

    const deactivateUser = useCallback(
        (item, index, property) => {
            const deactivatedUser = item.emailaddress;
            return (
                <Button
                    onClick={() => {
                        handleDeactivate(deactivatedUser);
                    }}>
                    {'Deactivate'}
                </Button>
            );
        }
    );


    const overrides = {
        claimListTableLoader: {
            loaded: !isLoading
        },
        claimTable: {
            data: userTable,
            visible: !isLoading
        },
        createnewuser: {
            to: CreateNewUser,
        },

        useraccess: {
            visible: false
        },


        globalizationChooserField: {
            onLanguageValueChange: localeService.saveLanguage,
            languageValue: localeService.getStoredLanguage()
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            CreateNewUser: CreateNewUser,
            editUser: editUser,
            resendLink: resendLink,
            deactivateUser: deactivateUser

        }
    };
    return renderContentFromMetadata(metadata.pageContent, overrides, resolvers);
}

export default withRouter(AgentListViewPage);